import CountryService from "./CountryService";
import AddressService from "./AddressService";
import PostalCodeService from "./PostalCodeService";
import IsoCodeService from "./IsoCodeService";

const country = CountryService.getInstance();
const address = new AddressService();
const postalCode = new PostalCodeService();
const isoCode = new IsoCodeService();

export const getCountryByName = (countryName: string) =>
  country.getByName(countryName);

export const getCountryCodeByName = (countryName: string) =>
  country.getCodeByName(countryName);

export const getCountryByPhoneCode = (phoneCode: string) =>
  country.getByPhoneCode(phoneCode);

export const getGroupedCountryCodes = () => country.getGroupedCodes();

export const getAddressStateLabel = (countryName: string) =>
  address.getStateLabel(countryName);

export const getAddressPostalLabel = (countryName: string) =>
  address.getPostalLabel(countryName);

export const shouldShowAddressState = (countryName: string) =>
  address.shouldShowState(countryName);

export const isAddressPostalBeforeCity = (countryName: string) =>
  address.isPostalBeforeCity(countryName);

export const getISOCountryCode = (countryName: string) =>
  isoCode.get(countryName);

export const getPostalCodePattern = (countryName: string) =>
  postalCode.getPattern(countryName);

export const validatePostalCode = (code: string, countryName: string) =>
  postalCode.validate(code, countryName);

export const formatPostalCode = (code: string, countryName: string) =>
  postalCode.format(code, countryName);

export const getPostalCodePlaceholder = (countryName: string) =>
  postalCode.getPlaceholder(countryName);

export {
  countryCodes,
  countriesFlat,
  countriesGrouped,
  phoneTypes,
} from "types";
